'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = Register;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uiComponents = require('@wh/ui-components');

require('./register.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Register button component
 * @param {RegisterPropsType} onClick Event handler.
 * @returns {Element} React element
 * @constructor
 */
function Register(_ref) {
    var t = _ref.t,
        onClick = _ref.onClick;

    return (0, _jsx3.default)('div', {
        className: 'c-login-form__register'
    }, void 0, (0, _jsx3.default)('span', {
        className: 'c-login-form__register-text'
    }, void 0, t('login')('modalRegisterText')), (0, _jsx3.default)(_uiComponents.NavItem, {
        type: 'default',
        style: 'default',
        size: 'large',
        className: 'c-login-form__register-link',
        onClick: onClick
    }, void 0, t('login')('modalRegisterLink')));
}
//# sourceMappingURL=register.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/register/register.js
// module id = 502
// module chunks = 0